module.exports = __webpack_public_path__ + "img/stop.8f27ed69.png";